module.exports = __webpack_public_path__ + "assets/img/Group_265@2x.7e5896fd.png";